import React from 'react'
import { Navigate } from 'react-router-dom'

import { UserRoles } from '../constants/roles'

import LoginPage from '../pages/login'
import CasesListPage from '../pages/list-cases'
import OrdersListPage from '../pages/list-orders'
import ListClients from '../pages/list-clients'
import TasksListOrderPage from '../pages/list-tasks-orders'
import EmployeeListPage from '../pages/list-employees'
import { TasksListPage } from '../pages/list-tasks'
import TasksCalendar from '../pages_v2/tasks-calendar-page'
import FrozesListPage from '../pages/list-measurements'
import ManufactureListPage from '../pages/list-manufacture'
import DeliveryListPage from '../pages/list-delivery'
import MountingListPage from '../pages/list-mounting'
import ListCallLog from '../pages_v2/list-call-log'
import FrozeCardPage from '../pages/card-measurement'
import EditCasePage from '../pages/card-case'
import EditOrderPage from '../pages/card-order'
import CardClient from '../pages/card-client'
import CardMountingPage from '../pages/card-mounting'
import CardDeliveryPage from '../pages/card-delivery'
import CardManufacturePage from '../pages/card-manufacture'
import CardEmployeePage from '../pages/card-employee'
import AuditCardPage from '../pages/card-audit'
import ComplaintCardPage from '../pages/card-complaint'
import PageListUsers from '../pages/list-users'
import PageCardUser from '../pages/card-user'
import PageListOrganizations from '../pages/list-organizations'
import PageCardOrganization from '../pages/card-organization'
import ReportsList from '../pages/list-reports'
import ReportCard from '../pages/card-report'
import PageListProfilesOrganizations from '../pages/list-profiles-organizations'
import PageCardProfileOrganization from '../pages/card-profile-organization'
import AuditListPage from '../pages/list-audit'
import ComplaintListPage from '../pages/list-complaint'
import ClaimsListPage from '../pages/list-claims'
import ClaimCardPage from '../pages/card-claim'
import ClaimRequestsListPage from '../pages/list-claim-requests'
import ClaimRequestCardPage from '../pages/card-claim-request'
import { AdminCollectionsListPage } from '../pages/list-admin-collections/admin-collections-list'
import AdminNewCollectionPage from '../pages/admin-new-collection'
import AdminEditCollectionPage from '../pages/admin-edit-collection'
import { AdminObjectsListPage } from '../pages/list-admin-objects'
import AdminNewObjectPage from '../pages/admin-new-object'
import AdminEditObjectPage from '../pages/admin-edit-object'
import AdminSchemasListPage from '../pages/list-admin-schemas'
import AdminNewSchemaPage from '../pages/admin-new-schema'
import AdminEditSchemaPage from '../pages/admin-edit-schema'
import { CalculatorPage } from '../pages/calculator'
import MailsListPage from '../pages/list-mails'
import CardMail from '../pages/card-mail'

import ReportMarketingCard from '../pages/card-report-marketing'
import ReportMarketingList from '../pages/list-report-marketing'
import HrListPage from '../pages/list-hr'
import HrCardPage from '../pages/card-hr/new'
import Tasks from '../pages_v2/tasks'
import { AdminListRoles, AdminEditRole } from '../pages_v2/admin/roles'
import AdminUsersPage from '../pages_v2/admin/users'
import NewClientCardPage from '../pages_v2/clients/card'
import NewListClients from '../pages_v2/clients/list'
import NewOrdersListPage from '../pages_v2/orders/list'
import CardOrder from '../pages_v2/orders/card'
import OrganizationsList from '../pages_v2/organizations/list'
import OrganizationCard from '../pages_v2/organizations/card'
import OfficesList from '../pages_v2/offices/list'
import OfficeCard from '../pages_v2/offices/card'
import UserCardPage from '../pages_v2/users/card'
import UsersListPage from '../pages_v2/users/list'
import Collections from '../pages_v2/admin/collections'
import Enum from '../pages_v2/admin/enum'
import NewCasesListPage from '../pages_v2/appeals/list'
import CardAppeal from '../pages_v2/appeals/card'
import Fields from '../pages_v2/admin/fields'
import FieldGroups from '../pages_v2/admin/field-groups'
import DadataTest from '../pages_v2/dadata-test'
import HrDashboard from '../pages/dashboard-hr'
import FeedbackFunnel from '../pages/feedback-funnel'
import HrPaymentsList from '../pages_v2/hr/payments/list'
import HrPaymentsCard from '../pages_v2/hr/payments/card'
import HrPlansList from '../pages_v2/hr/plans/list'
import EmployeeCard from '../pages_v2/employees/card'
import EmployeesListPage from '../pages/employees/list'
import EmployeeCardPage from '../pages/employees/card'
import MenuEditor from '../pages_v2/admin/menu_editor'
import LogisticDeliveryListPage from '../pages_v2/deliveries/list'
import LogisticRouteSheetsListPage from '../pages_v2/route-sheets/list'
import LogisticDeliveryCardPage from '../pages_v2/deliveries/card'
import LogisticVehiclesListPage from '../pages_v2/logistics-vehicles/list'
import MeasurementsList from '../pages_v2/mesurements/list'
import MeasurementsCardPage from '../pages_v2/mesurements/card'
import MontageList from '../pages_v2/montage/list'
import MontageCardPage from '../pages_v2/montage/card'
import Migration from '../pages_v2/migration'
import { OrderStagePlanEditor } from '../pages_v2/admin/order-stage-plan'
import { ClaimStagePlanEditor } from '../pages_v2/admin/claim-stage-plan'
import SystemThemePage from '../pages_v2/admin/system-theme'
import NotificationSoundsPage from '../pages_v2/admin/notification-sounds'
import MyProfilePage from '../pages_v2/my-profile'
import { OrdersDashboardPage } from '../pages_v2/orders-dashboard'
import { SvetoforDashboardPage } from '../pages_v2/svetofor-dashboard'
import DocumentTemplates from '../pages_v2/document-templates'
import { PowerbiReport } from '../pages_v2/powerbi-report'
import DeliveryZonesEditor from '../pages_v2/admin/delivery-zones'
import ClaimsRequestsList from '../pages_v2/claims-request/list'
import ClaimRequest from '../pages_v2/claims-request/card'
import ClaimsList from '../pages_v2/claims/list'
import ClaimPage from '../pages_v2/claims/claim/index'
import ClaimsWorksList from '../pages_v2/claims-works/list'
import ClaimsWorksCard from '../pages_v2/claims-works/card'
import EmailMonitor from '../pages/email-monitor'
import { AI2UiEmbed, AIUiEmbed } from '../pages_v2/ai-reports'
import DocumentEditor from '../pages_v2/document-editor'
import {
  DeliveryCalendarPage,
  ProcurementCard,
  ProcurementPage,
  SupplyRequestCard,
  SupplyRequestsPage,
  SupplyReviewPage,
  IncomingDocumentsPage,
  WarehouseCard,
  WarehousePage,
} from '../pages_v2/supply'

export type RouteConfig = {
  path: string
  element: JSX.Element
  private?: boolean
  allowedRoles?: number[]
}

export const routes: RouteConfig[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/profile', element: <MyProfilePage />, private: true },
  { path: '/procurement', element: <ProcurementPage />, private: true },
  { path: '/procurement/requests', element: <SupplyRequestsPage />, private: true },
  { path: '/procurement/requests/:number', element: <SupplyRequestCard />, private: true },
  { path: '/procurement/:number', element: <ProcurementCard />, private: true },
  { path: '/warehouse', element: <WarehousePage />, private: true },
  { path: '/warehouse/deliveries', element: <DeliveryCalendarPage />, private: true },
  { path: '/warehouse/incoming', element: <IncomingDocumentsPage />, private: true },
  { path: '/warehouse/reviews', element: <SupplyReviewPage />, private: true },
  { path: '/warehouse/reviews/:id', element: <SupplyReviewPage />, private: true },
  { path: '/warehouse/:number', element: <WarehouseCard />, private: true },
  { path: '/call-center/cases', element: <CasesListPage />, private: true },
  { path: '/sales/orders', element: <OrdersListPage />, private: true },
  { path: '/call-center/clients', element: <ListClients />, private: true },
  { path: '/mails', element: <MailsListPage />, private: true },
  { path: '/mails/:id', element: <CardMail />, private: true },
  { path: '/employees', element: <EmployeeListPage />, private: true },
  { path: '/planning/tasks', element: <TasksListPage />, private: true },
  { path: '/planning/tasks-orders', element: <TasksListOrderPage />, private: true },
  { path: '/sales/measurements', element: <FrozesListPage />, private: true },
  { path: '/production-page', element: <ManufactureListPage />, private: true },
  { path: '/logistic-delivery', element: <DeliveryListPage />, private: true },
  { path: '/sales/mounting', element: <MountingListPage />, private: true },
  { path: '/call-center-telephony', element: <ListCallLog />, private: true },
  { path: '/froze/:id/edit', element: <FrozeCardPage />, private: true },
  { path: '/case/:id/edit', element: <EditCasePage />, private: true },
  { path: '/order/:id/edit', element: <EditOrderPage />, private: true },
  { path: '/clients/:id', element: <CardClient />, private: true },
  { path: '/mounting/:id/edit', element: <CardMountingPage />, private: true },
  { path: '/delivery/:id/edit', element: <CardDeliveryPage />, private: true },
  { path: '/manufacture/:id/edit', element: <CardManufacturePage />, private: true },
  { path: '/employees/:id', element: <CardEmployeePage />, private: true },
  { path: '/audit/:id/edit', element: <AuditCardPage />, private: true },
  { path: '/complaint/:id/edit', element: <ComplaintCardPage />, private: true },
  { path: '/users', element: <PageListUsers />, private: true },
  { path: '/user/:id', element: <PageCardUser />, private: true },
  { path: '/organizations', element: <PageListOrganizations />, private: true },
  { path: '/organizations/:id', element: <PageCardOrganization />, private: true },
  { path: '/reports', element: <ReportsList />, private: true },
  { path: '/report/marketing', element: <ReportMarketingCard />, private: true },
  { path: '/report/marketing-list', element: <ReportMarketingList />, private: true },
  { path: '/report/:id', element: <ReportCard />, private: true },
  { path: '/profiles-organization', element: <PageListProfilesOrganizations />, private: true },
  { path: '/profile-organization/:id', element: <PageCardProfileOrganization />, private: true },
  { path: '/sales/audit', element: <AuditListPage />, private: true },
  { path: '/sales/complaint', element: <ComplaintListPage />, private: true },
  { path: '/reports-satels/claims', element: <ClaimsListPage />, private: true },
  { path: '/claims/:id', element: <ClaimCardPage />, private: true },
  { path: '/claims/:id/edit', element: <ClaimCardPage />, private: true },
  { path: '/claim-requests', element: <ClaimRequestsListPage />, private: true },
  { path: '/claim-requests/:id', element: <ClaimRequestCardPage />, private: true },
  { path: '/claim-requests/:id/edit', element: <ClaimRequestCardPage />, private: true },
  { path: '/hr/payments', element: <HrPaymentsList />, private: true },
  { path: '/hr/payments/:id', element: <HrPaymentsCard />, private: true },
  { path: '/hr/plans', element: <HrPlansList />, private: true },
  { path: '/hr-employees', element: <EmployeesListPage />, private: true },
  { path: '/hr-employees/:id', element: <EmployeeCardPage />, private: true },
  { path: '/hr/dashboard', element: <HrDashboard />, private: true },
  { path: '/reports-sales-contracts', element: <OrdersDashboardPage />, private: true },
  { path: '/hr/feedback-funnel', element: <FeedbackFunnel />, private: true },
  { path: '/hr', element: <HrListPage />, private: true },
  { path: '/hr/:id', element: <HrCardPage />, private: true },
  {
    path: '/admin',
    element: <AdminCollectionsListPage />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  {
    path: '/admin/collections',
    element: <AdminCollectionsListPage />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  { path: '/admin/collections/new', element: <AdminNewCollectionPage />, private: true },
  { path: '/admin/collections/:id', element: <AdminEditCollectionPage />, private: true },
  { path: '/admin/collections/:name/objects', element: <AdminObjectsListPage />, private: true },
  { path: '/admin/collections/:name/objects/new', element: <AdminNewObjectPage />, private: true },
  {
    path: '/admin/collections/:name/objects/:id/:group/edit',
    element: <AdminEditObjectPage />,
    private: true,
  },
  { path: '/admin/schemas', element: <AdminSchemasListPage />, private: true },
  { path: '/admin/schemas/new', element: <AdminNewSchemaPage />, private: true },
  { path: '/admin/schemas/:id', element: <AdminEditSchemaPage />, private: true },
  { path: '/calculator', element: <CalculatorPage />, private: true },
  { path: '/admin/roles', element: <AdminListRoles />, private: true },
  { path: '/dashboard', element: <SvetoforDashboardPage />, private: true },
  { path: '/svetofor-dashboard', element: <Navigate to="/dashboard" replace />, private: true },
  {
    path: '/admin/users',
    element: <AdminUsersPage />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  { path: '/admin/role/:id', element: <AdminEditRole />, private: true },
  { path: '/appeals', element: <NewCasesListPage />, private: true },
  { path: '/appeal/:id', element: <CardAppeal />, private: true },
  { path: '/orders', element: <NewOrdersListPage />, private: true },
  { path: '/order/:id', element: <CardOrder />, private: true },
  { path: '/call-center/new-clients', element: <NewListClients />, private: true },
  { path: '/client-new/:id', element: <NewClientCardPage />, private: true },
  { path: '/admin/fields', element: <Fields />, private: true },
  {
    path: '/admin/field-groups',
    element: <FieldGroups />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  { path: '/tasks', element: <Tasks />, private: true },
  { path: '/tasks/calendar', element: <TasksCalendar />, private: true },
  { path: '/new/organizations', element: <OrganizationsList />, private: true },
  { path: '/new/organization/:id', element: <OrganizationCard />, private: true },
  { path: '/offices/:id', element: <OfficesList />, private: true },
  { path: '/office/:id', element: <OfficeCard />, private: true },
  { path: '/office/:organization_id/new', element: <OfficeCard />, private: true },
  { path: '/users-new', element: <UsersListPage />, private: true },
  { path: '/users-new/:id', element: <UserCardPage />, private: true },
  { path: '/admin/enum-collections', element: <Collections />, private: true },
  { path: '/admin/enum-collection/:id', element: <Enum />, private: true },
  { path: '/dadata-test', element: <DadataTest />, private: true },
  { path: '/employees_new/:user_id', element: <EmployeeCard />, private: true },
  { path: '/admin/menu-editor', element: <MenuEditor />, private: true },
  { path: '/logistics/deliveries', element: <LogisticDeliveryListPage />, private: true },
  { path: '/logistics/route-sheets', element: <LogisticRouteSheetsListPage />, private: true },
  { path: '/logistics/vehicles', element: <LogisticVehiclesListPage />, private: true },
  { path: '/logistics/deliveries/:id', element: <LogisticDeliveryCardPage />, private: true },
  { path: '/measurements', element: <MeasurementsList />, private: true },
  { path: '/measurements/:id', element: <MeasurementsCardPage />, private: true },
  { path: '/montage', element: <MontageList />, private: true },
  { path: '/montage/:id', element: <MontageCardPage />, private: true },
  { path: '/migration', element: <Migration />, private: true },
  { path: '/admin/order-stage-plan', element: <OrderStagePlanEditor />, private: true },
  { path: '/admin/claim-stage-plan', element: <ClaimStagePlanEditor />, private: true },
  {
    path: '/admin/system-theme',
    element: <SystemThemePage />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  {
    path: '/admin/notification-sounds',
    element: <NotificationSoundsPage />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  { path: '/document-templates', element: <DocumentTemplates />, private: true },
  { path: '/powerbi-report', element: <PowerbiReport />, private: true },
  { path: '/claims-requests', element: <ClaimsRequestsList />, private: true },
  { path: '/claim-request/:id', element: <ClaimRequest />, private: true },
  { path: '/claims', element: <ClaimsList />, private: true },
  { path: '/claim/:id', element: <ClaimPage />, private: true },
  { path: '/claims-works', element: <ClaimsWorksList />, private: true },
  { path: '/claim-work/:id', element: <ClaimsWorksCard />, private: true },
  { path: '/admin/email-monitor', element: <EmailMonitor />, private: true },
  { path: '/admin/delivery-zones', element: <DeliveryZonesEditor />, private: true },
  {
    path: '/ai/integrations/*',
    element: <AIUiEmbed />,
    private: true,
    allowedRoles: [UserRoles.ADMIN],
  },
  {
    path: '/ai/*',
    element: <AIUiEmbed />,
    private: true,
  },
  {
    path: '/ai2/*',
    element: <AI2UiEmbed />,
    private: true,
  },
  { path: '/document_editor/:id', element: <DocumentEditor />, private: true },
]
